module.exports = __webpack_public_path__ + "img/contact-map-locations.1a89435d.webp";